// Solr Documents embed weren't showing caption options on the main admin page.
// This overrideds the plank item options to show caption options (Like other sir trevor blocks)
SirTrevor.Blocks.SolrDocumentsEmbed = (function(){

  return SirTrevor.Blocks.SolrDocumentsEmbed.extend({
    item_options: function() {
      return this.caption_options();
    },
  });
})();